<template>
    <div class="splash-content">
      <div class="header-img">
          <img src="../../assets/imgs/img_splash_header.png" alt="">
      </div>
      <div class="verification-group">
          <div class="verification-item">
              <img :src="skuVerifyIcon" alt="">
              <span class="verify-text">{{$t('app.verify.sku')}}</span>
              <span :class="process ? 'verify-result-processing' : (skuVerify ? 'verify-result-pass': 'verify-result-fail')">{{process ? $t('app.verify.process') : ( skuVerify ? $t('app.verify.pass') : $t('app.verify.fail'))}}</span>
          </div>
          <div class="verification-item">
              <img :src="chipVerifyIcon" alt="">
              <span class="verify-text">{{$t('app.verify.chip')}}</span>
              <span :class="process ? 'verify-result-processing' : (chipVerify ? 'verify-result-pass': 'verify-result-fail')">{{ process ? $t('app.verify.process') : ( chipVerify ? $t('app.verify.pass') : $t('app.verify.fail') )}}</span>
          </div>
      </div>
      <div class="display-btn" @click="enterLp">
          <div class="user-check" v-if="showConnectUser">{{$t('app.verify.user')}}</div>
          <div class="btn-container">
              <div class="btn-bg">
                  <img src="../../assets/imgs/landing_view_btn.png" alt="" width="267" height="48">
              </div>
              <div class="text"><span>{{$t('app.verify.view')}}</span></div>
          </div>
      </div>
      <div class="ve-footer">
          <img alt="icon" src="../../assets/imgs/vechain_powered_text.png">
      </div>
    </div>
  </template>
  
  <script>
  
  import { getParams } from '@/utils/sdk'

  import Axios from 'axios'
  const axios = Axios.create({});
  
  export default {
    data() {
      return {
        chipVerify: "unverifyed",
        showConnect: false,
      }
    },
    components: {
    },
    props: {
      explorerUrl: String,
      tracks: Array,
      template: Number,
      process: Boolean,
      skuVerify: Boolean
    },
    computed: {
      skuVerifyIcon() {
          console.log("process", this.process)
          console.log("sku_exist", this.skuVerify)
          if(this.process){
              return require("../../assets/imgs/icon_verification_process.png")
          }
          if(this.skuVerify) {
              return require("../../assets/imgs/icon_verification_pass.png")
          }
          return require("../../assets/imgs/icon_verification_fail.png")
      },
      chipVerifyIcon() {
          if(this.process){
              return require("../../assets/imgs/icon_verification_process.png")
          }
          if(this.chipVerify) {
              return require("../../assets/imgs/icon_verification_pass.png")
          }
          return require("../../assets/imgs/icon_verification_fail.png")
      },
      showConnectUser() {
          return !this.chipVerify && !this.process
      },
    //   chipVerifyPass() {
    //     return this.chipVerify && this.chipVerify.toLowerCase() == 'pass'
    //   }
    },
    methods: {
      enterLp() {
          this.$emit('enterLandingPage')
      },
      // getInfos() {
      //   var params = getUrlAllParams()
      //   var langCode = getLangCode(navigator.language)
      //   params = { language: langCode, ...params }
  
  
      //   // var dataurl = process.env.VUE_APP_HOST
      //   // if (internal == true || internal == 'true') {
      //   //   dataurl = process.env.VUE_APP_INTERNAL_HOST
      //   // }
      //   let v3DataUrl = process.env.VUE_APP_SKU_HOST;
      //   console.log("v3DataUrl", v3DataUrl);
      //   /// get sku first
      //   var reqData = { ...params, domain: window.location.host, language: params.language , token: '706f776572656462797665636861696e'}
  
      //   var cfg =  configJson.config
  
      //   var skuUuid = cfg.sku.key
      //     var that = this
      //   axios({
      //     url: v3DataUrl,
      //     data: reqData,
      //     method: 'POST'}).then(resp => {
  
      //       if(resp.data && resp.data.code == 'common.success'){
      //         this.loading = false
      //         var cfg =  configJson.config
  
      //         var skuUuid = cfg.sku.key
      //         let skuUuidObj = resp.data.data && resp.data.data.jsonData && resp.data.data.jsonData[skuUuid] || {};
    
      //         let skuInfo = {
      //           ...(skuUuidObj.base || {}),
      //           ...(skuUuidObj.custom || {}),
      //           ...(skuUuidObj.blockinfo || {}),
      //           verificationInfo: (skuUuidObj && skuUuidObj.verificatoninfo) || (skuUuidObj && skuUuidObj.verificationinfo) || [],
      //         }
      //         that.skuVerify = Object.keys(skuInfo).length > 0
      //       }
  
      //         // this.getDcps(params)
      //     }).catch(error => {
  
      //         // this.getDcps(params)
      //     })
          
      // }
    },
    mounted() {
      // this.getInfos()
      let params = getParams()
      let verifyResult = params['verifyResult']
      let vidAccessToken = params['vidAccessToken']
      this.chipVerify = (verifyResult && verifyResult.toLowerCase() == 'pass') && (vidAccessToken && vidAccessToken.length > 0)
      if(verifyResult && verifyResult.toLowerCase() == 'fail') {
          this.showConnect = true
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .splash-content {
      width: 100vw;
      height: 100vh;
      max-width: 750px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .header-img {
        //   height: 493px;
          width: 100vw;
          max-width: 750px;
          img {
            //   height: 493px;
              width: 100vw;
              max-width: 750px;
              object-fit: contain;
          }
      }
  
      .verification-group {
          .verification-item {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              max-width: 750px;
              img {
                  width: 24px;
                  height: 24px;
              }
              font-family: PingFang SC;
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
              letter-spacing: 0px;
              text-align: left;
              color: #2E3440;
              span {
                  margin-left: 8px;
              }
              .verify-text {
                  width: calc(100vw - 130px);
                  max-width: 620px;
              }
              .verify-result-pass {
                  width: 60px;
                  color: #2CCE7F;
              }
              .verify-result-fail {
                  width: 60px;
                  color: #FF6D6D;
              }
              .verify-result-processing {
                  width: 60px;
                  color: transparent;
              }
          }
      }
  
      .user-check {
          font-family: PingFang SC;
          font-size: 12px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0px;
          text-align: center;
          color: #FF6D6D;
          padding: 8px;
      }
      .display-btn {
          flex: 1;
          display: flex;
          // position: relative;
          align-items: center;
          justify-content: center;
          flex-direction: column;
  
          .btn-container {
              position: relative;
              width: 100%;
              .btn-bg {
                  display: flex;
                  align-items: center;
                  justify-content: center;
              }
          }
          .text {
              position: absolute;
              top:0;
              left: 0;
              right: 0;
              bottom: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              span {
                  z-index: 10;
              }
          }
      }
  
      .ve-footer {
          padding: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100vw;
          max-width: 750px;
          img {
              width: 120px;
              height: 19px;
          }
      }
      // max-width: 750px;
  }
  
  </style>
  